import { runDemo } from "../shared/demoRunner";
import { createOctreeScene } from "./scene";

runDemo({ createScene: createOctreeScene });
